<template>
  <div class='masonry-container' ref="masonryContainer" v-infinite-scroll='loadMore'
       :infinite-scroll-disabled='loading || noMoreData' :infinite-scroll-distance="100"
       :infinite-scroll-immediate='false'>
    <!-- 测试字体是否加载 -->
    <template v-if="dataList.length !== 0">
      <el-card class='card' v-for='(item) in dataList' :key='item.id' shadow='hover'>
        <el-skeleton animated :loading='loading'>
          <template slot='template'>
            <el-skeleton-item variant='image' style='width: 240px; height: 240px;' />
            <div style='padding: 14px;'>
              <el-skeleton-item variant='p' style='width: 50%' />
              <div style='display: flex; align-items: center;'>
                <el-skeleton-item variant='text' style='margin-right: 16px;' />
                <el-skeleton-item variant='text' style='width: 30%;' />
              </div>
            </div>
          </template>
          <template>
            <div class="product-container">
              <div class='card_content'>
                <div class="content-wrapper">
                  <div class="skewed-triangle"></div>
                  <span>{{ item.title || '' }} </span><br/>

                  <span><span class="field-label">规格：</span>{{ item.spec_name || '' }} </span><br v-if="item.spec_name && item.spec_name !== ''"/>
                  <span v-if="item.spec_color && item.spec_color !== ''"><span class="field-label">色号/香型：</span>{{
                    item.spec_color || ''
                  }} </span><br v-if="item.spec_color && item.spec_color !== ''"/>
                  <span v-if="item.used_season && item.used_season !== ''"><span class="field-label">季节性：</span>{{
                    item.used_season || ''
                  }} </span><br v-if="item.used_season && item.used_season !== ''"/>
                  <span><span class="field-label">品牌：</span>{{ item.brand_name || '' }} </span><br/>
                  <span><span class="field-label">可播平台：</span>{{ item.platform_names || '' }}</span><br/>
                  <span><span class="field-label">日常价：</span><a>{{ item.price || '' }}元</a> </span><br/>
                  <span><span class="field-label">直播价：</span><a>{{ item.lb_price || '' }}元</a> </span><br/>
                  <span><span class="field-label">赠品：</span>{{ item.gift || '' }} </span><br/>
                  <span><span class="field-label">坑位费：</span><a>{{ item.ad_space_fee || '暂无' }}</a></span><br v-if="item.ad_space_fee"/>
                  <span v-if="item.online_cmn"><span class="field-label">线上佣金(%)：</span><a>{{
                    item.online_cmn ? item.online_cmn : '' || '暂无'
                  }}</a></span>
                  <span v-else-if="item.offline_cmn"><span class="field-label">线下佣金(%)：</span><a>{{
                    item.offline_cmn ? item.offline_cmn : '' || '/'
                  }}</a></span><br v-if="item.online_cmn || item.offline_cmn"/>
                  <span><span class="field-label">是否统一机制：</span>{{ item.unify === 1 ? '是' : '否' || '/' }}<a v-if='item.unify === 2'> /{{
                    item.special_remark ||
                      '/'
                  }} </a></span>
                  <br/> <span><span class="field-label">是否有签独家：</span>{{ item.exclusive === 1 ? '是' : '否' }}<a v-if='item.exclusive === 1'>/{{
                    item.other_activity ||
                      '/'
                  }}</a></span>
                  <br/> <span><span class="field-label">是否签保价协议：</span>{{ item.support_value === 1 ? '是' : '否' }}</span>
                  <br/> <span><span class="field-label">店铺名称：</span>{{ item.company_name || '/' }}</span>
                  <br/> <span><span class="field-label">备注：</span>{{ item.remark || '/' }}</span>
                  <br/> <span><span class="field-label">负责人：</span>{{ item.leader_name || '/' }}</span>
                </div>
              </div>

              <div class="product-background"
                   :style="{ '--bg-image': 'url(' + (item.cover_url || require('@/assets/icons/no_img_available.png')) + ')' }">
              </div>

              <div class="hotspot-area"></div>

              <img v-if="item.is_sec_kill === 'Y'" src='@/assets/icons/seckill2.png' alt="秒杀标识"
                   class="seckill-badge"/>
              <div class="id-badge">{{ item.id }}</div>
            </div>

            <div class="button-container">
              <el-link type='primary' icon='el-icon-edit' @click='handleEdit(item)'>修改
              </el-link>
              <el-tooltip content='添加到直播选品' placement='top' effect='light'>
                <el-link type='primary' icon='el-icon-shopping-cart-2' @click='handleJoinLive(item)'>选品
                </el-link>
              </el-tooltip>
              <el-tooltip content='预览产品PPT展示' placement='bottom' effect='light'>
                <el-link type='primary' icon='el-icon-s-platform' @click='handleCheck(item)'>PPT
                </el-link>
              </el-tooltip>
              <product-version-list v-if='userPermissions.indexOf("product_version") > -1' :key='item.id'
                                    :product-id='item.id' :product-name='item.title' :c-type="parseInt(isType)" />
            </div>
          </template>
        </el-skeleton>
      </el-card>

    </template>
    <template v-else>
      <h1 class="text"> o(╥﹏╥)o
        <br /> <br />暂无数据
      </h1>
    </template>

    <div class="load-more-container" v-if="dataList.length > 0">
      <div v-if="loadingMore" class="loading-text">
        <i class="el-icon-loading"></i> 加载中...
      </div>
      <div v-else-if="noMoreData" class="no-more-text">
        没有更多数据了
      </div>
    </div>

    <div class="back-to-top" :class="{ 'show': showBackToTop }" @click="scrollToTop">
      <i class="el-icon-caret-top"></i>
    </div>

  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import ProductImage from './ProductImage'
import ProductVersionList from './history/list.vue'
import Masonry from 'masonry-layout'

export default {
  name: 'ProductListUpdated',
  computed: {
    ...mapGetters(['userPermissions']),
    noMoreData() {
      return this.dataList.length >= this.total && this.total > 0
    }
  },
  components: {
    ProductImage, ProductVersionList
  },
  props: {
    isType: {
      type: Number,
      default() {
        return 1
      }
    },
    searchCondition: {
      type: Object
    }
  },
  data() {
    return {
      dataList: [],
      total: 0,
      loading: false,
      loadingMore: false,
      orderSort: {id: 'desc'},
      pageData: {page_size: 20, current_page: 1},
      isInitLoading: true,
      masonry: null,
      refreshTimer: null,
      showBackToTop: false,
      scrollThreshold: 300,
      hoverCleanups: []

    }
  },

  methods: {
    // 动态添加CSS样式
    addDynamicStyles() {
      // 创建style元素
      const styleElement = document.createElement('style');
      styleElement.id = 'dynamic-secondary-nav-styles';

      // 添加CSS样式
      styleElement.textContent = `
       .main-content_bg {
          min-height: auto;
          height: calc(100vh - 140px) !important;
        }
      `;
      // 添加到head
      document.head.appendChild(styleElement);
    },

    // 移除动态添加的CSS样式
    removeDynamicStyles() {
      const styleElement = document.getElementById('dynamic-secondary-nav-styles');
      if (styleElement && styleElement.parentNode) {
        styleElement.parentNode.removeChild(styleElement);
      }
    },
    handleEdit(row) {
      this.$emit('handleEdit', row)
    },
    handleJoinLive(row) {
      this.$emit('handleJoinLive', row)
    },
    handleCheck(row) {
      this.$emit('handleCheck', row)
    },
    handleDetails(row) {
      this.$emit('handleDetails', row)
    },
    async getList() {
      if (this.loading) {
        return
      }
      this.loading = true
      this.pageData.current_page = 1
      const params = { ...this.searchCondition, ...this.pageData, order: this.orderSort }

      let apiMethod = this.isType === 2 ? 'getProductVideoList' : 'getProductList'
      let {list, pages} = await this.$api[apiMethod](params)
      this.dataList = list || []
      this.pageData.current_page = pages.current_page || 1
      this.pageData.page_size = pages.page_size || 20
      this.total = pages.total || 0
      this.loading = false
      this.isInitLoading = false
      this.initMasonry()
    },
    refreshList() {
      if (this.loading) {
        return
      }
      this.pageData.current_page = 1
      this.getList()
    },
    initMasonry() {
      this.$nextTick(() => {
        if (this.masonry) {
          this.masonry.destroy()
        }
        const container = this.$refs.masonryContainer
        if (container) {
          this.masonry = new Masonry(container, {
            itemSelector: '.card',
            columnWidth: '.card',
            gutter: 10,
            percentPosition: true,
            transitionDuration: '0.3s'
          })
        }
      })
    },
    updateMasonry() {
      this.$nextTick(() => {
        if (this.masonry) {
          this.masonry.reloadItems()
          this.masonry.layout()
        }
      })
    },
    async loadMore() {
      if (this.loadingMore || this.noMoreData || this.isInitLoading) {
        return
      }

      this.loadingMore = true
      this.pageData.current_page += 1

      const params = { ...this.searchCondition, ...this.pageData, order: this.orderSort }

      try {
        let apiMethod = this.isType === 2 ? 'getProductVideoList' : 'getProductList'
        let {list, pages} = await this.$api[apiMethod](params)
        if (list && list.length > 0) {
          this.dataList = [...this.dataList, ...list]
          this.total = pages.total || 0
          this.updateMasonry()
        }
      } catch (error) {
        console.error('加载更多数据失败:', error)
        this.pageData.current_page -= 1
      } finally {
        this.loadingMore = false
      }
    },
    scrollToTop() {
      const container = this.$refs.masonryContainer
      if (container) {
        container.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      }
    },
    handleScroll() {
      const container = this.$refs.masonryContainer
      if (container) {
        this.showBackToTop = container.scrollTop > this.scrollThreshold
      }
    },

    removeHoverEvents() {
      this.hoverCleanups.forEach(cleanup => cleanup())
      this.hoverCleanups = []
    },
    addHoverEvents() {
      this.$nextTick(() => {
        this.removeHoverEvents()
        document.querySelectorAll('.hotspot-area').forEach(element => {
          const productBackground = element.parentElement.querySelector('.product-background');
          let mouseStop = false
          let enterIntervalId = null
          let leaveTimeoutId = null
          let moveTimerId = null

          const onMouseMove = () => {
            clearTimeout(moveTimerId)
            mouseStop = false
            moveTimerId = setTimeout(() => {
              mouseStop = true
            }, 20)
          }

          const onMouseLeave = () => {
            clearTimeout(moveTimerId)
            clearInterval(enterIntervalId)
            leaveTimeoutId = setTimeout(() => {
              if (productBackground) {
                productBackground.classList.remove('is-hovering')
                productBackground.classList.add('is-leaving')
              }
            }, 0)
          }

          const onMouseEnter = () => {
            clearTimeout(leaveTimeoutId)
            enterIntervalId = setInterval(() => {
              if (mouseStop && productBackground) {
                productBackground.classList.remove('is-leaving')
                productBackground.classList.add('is-hovering')
              }
            }, 25)
          }

          element.addEventListener('mousemove', onMouseMove)
          element.addEventListener('mouseleave', onMouseLeave)
          element.addEventListener('mouseenter', onMouseEnter)

          this.hoverCleanups.push(() => {
            element.removeEventListener('mousemove', onMouseMove)
            element.removeEventListener('mouseleave', onMouseLeave)
            element.removeEventListener('mouseenter', onMouseEnter)
            clearTimeout(moveTimerId)
            clearInterval(enterIntervalId)
            clearTimeout(leaveTimeoutId)
          })
        })
      })
    },

    isHighCommission(item) {
      if (item) {
        return item.ad_space_fee > 0 || item.online_cmn > 35 || item.offline_cmn > 35
      } else return false
    }
  },
  mounted() {
    this.getList()
    const container = this.$refs.masonryContainer
    if (container) {
      container.addEventListener('scroll', this.handleScroll)
    }
    this.addHoverEvents();
    this.addDynamicStyles(); // 动态添加CSS样式
  },
  updated() {
    this.updateMasonry()
    this.addHoverEvents() // 每次数据更新后重新绑定事件
  },
  beforeDestroy() {
    if (this.masonry) {
      this.masonry.destroy()
    }
    const container = this.$refs.masonryContainer
    if (container) {
      container.removeEventListener('scroll', this.handleScroll)
    }
    this.removeHoverEvents()
    this.removeDynamicStyles()
  },
  watch: {
    searchCondition: {
      handler() {
        if (this.refreshTimer) {
          clearTimeout(this.refreshTimer)
        }
        this.refreshTimer = setTimeout(() => {
          this.refreshList()
        }, 300)
      },
      deep: true,
      immediate: false
    }
  }
}
</script>
<style lang='scss' scoped>
::v-deep .el-card__body {
  padding: 10px !important;

}


$primary-color: #ff3176;
$success-color: #67C23A;
$warning-color: #E6A23C;
$danger-color: #F56C6C;
$info-color: #909399;
$text-primary: black;
$text-regular: #606266;
$text-secondary: #909399;
$text-placeholder: #C0C4CC;
$border-color: #DCDFE6;
$background-color: #F5F7FA;

.button-container {
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
  padding-top: 2px;
  margin-bottom: -8px;
  border-top: 1px solid $border-color;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;

  .el-link {
    height: 18px;
    line-height: 18px;
    flex: 1;
    min-width: 0;
    max-width: 25%;
    font-size: 14px;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 4px 0;

    &:hover {
      transform: translateY(-1px);
    }
  }
}

.masonry-container {
  width: 100%;
  box-sizing: border-box;
  height: calc(100% - 36px) !important;
  min-height: 740px;
  overflow-y: scroll;
  transition: all 0.3s ease;

  > .card {
    cursor: pointer;
    width: calc(20% - 15px);
    margin-bottom: 12px;
    transition: all 0.5s ease;
    border: 1px solid $border-color;
    border-radius: 6px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    break-inside: avoid;

    .product-container {
      position: relative;
      flex: 1;
      display: block;
      width: 100%;
      min-height: 200px;
    }

    .product-background {
      position: absolute;
      top: 0;
      right: 30%;
      width: 40%;
      height: 100%;

      &::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 0; // 初始定位在左侧
        width: 200px;
        height: 200px;
        background-image: var(--bg-image);
        background-size: contain;
        background-position: center center;
        background-repeat: no-repeat;
        transform: translateX(50%) translateY(-50%) scale(1) translateZ(0); // 初始变换
        z-index: 1;
        will-change: transform;
        pointer-events: none;
        backface-visibility: hidden;
        -webkit-backface-visibility: hidden;
      }
      &.is-hovering::before {
        animation: productImageEnter 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
        z-index: 70;
      }
      &.is-leaving::before {
        animation: productImageLeave 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
      }
    }

    .card_content {
      position: relative;
      z-index: 2;
      width: 100%;
      //padding: 8px;
      transition: all 0.3s ease;
      box-sizing: border-box;

      .content-wrapper {
        overflow-x: hidden;
        width: 100%;
        z-index: 1;
        position: relative;

        > span {
          display: inline-block;
          font-size: 14px;
          line-height: 1.2;
          margin: 2px 0;
          color: $text-primary;
          word-break: break-word;
          font-weight: 500;
          background: rgba(255, 255, 255, 0.85);
          padding: 1px 3px;
          border-radius: 2px;
          max-width: 100%;

          .field-label {
            color: #71757F;
            padding: 1px 0px;
            border-radius: 2px;
            margin-right: 2px;
          }

          > a {
            color: $danger-color;
            font-weight: 600;
            text-decoration: none;
            transition: color 0.3s ease;

            &:hover {
              color: darken($danger-color, 15%);
              text-decoration: underline;
            }
          }
        }
      }
    }

    .badge-container {
      position: absolute;
      top: -4px;
      right: -4px;
      display: flex;
      flex-direction: row-reverse;
      align-items: flex-start;
      gap: 8px;
      z-index: 44;
    }

    .seckill-text-badge {
      font-family: font_ms;
      font-size: 30px;
      letter-spacing: -8px;
      font-weight: 500;
      color: #ff3176;
      transform: rotate(15deg);
      text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);
      white-space: nowrap;
    }

    .commission-text-badge {
      font-family: font_gy;
      font-size: 30px;
      letter-spacing: -8px;
      font-weight: 500;
      color: #f59a23;
      transform: rotate(15deg);
      text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);
      white-space: nowrap;
    }


    .id-badge {
      position: absolute;
      bottom: 8px;
      right: -10px;
      background-color: #ff3176;
      color: white;
      font-size: 12px;
      font-weight: bold;
      padding: 4px 10px;
      border-radius: 12px;
      z-index: 45;
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
      transition: all 0.3s ease;
      height: 18px;
      line-height: 18px;
      border-bottom-right-radius: 0;
      border-top-right-radius: 0;

    }

    .hotspot-area {
      position: absolute;
      top: 50%;
      right: 10%;
      width: 200px;
      height: 200px;
      transform: translate(50%, -50%);
      z-index: 50;
      cursor: pointer;
    }


    .el-skeleton {
      .el-skeleton__item {
        border-radius: 4px;
      }
    }
  }

  .empty-state {
    width: 100%;
    text-align: center;
    margin: 60px 0;
  }

  .load-more-container {
    width: 100%;
    text-align: center;
    padding: 20px 0;
    break-inside: avoid;

    .loading-text {
      color: $primary-color;
      font-size: 14px;

      .el-icon-loading {
        margin-right: 8px;
        animation: rotating 2s linear infinite;
      }
    }

    .no-more-text {
      color: $text-secondary;
      font-size: 14px;
    }
  }

  .back-to-top {
    position: fixed;
    bottom: 40px;
    right: 40px;
    width: 50px;
    height: 50px;
    background-color: $primary-color;
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    transition: all 0.3s ease;
    opacity: 0;
    visibility: hidden;
    transform: translateY(20px);
    z-index: 1000;

    &.show {
      opacity: 1;
      visibility: visible;
      transform: translateY(0);
    }

    &:hover {
      background-color: darken($primary-color, 10%);
      transform: translateY(-2px);
      box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
    }

    i {
      font-size: 20px;
      font-weight: bold;
    }
  }

}

@keyframes productImageEnter {
  from {
    transform: translateX(50%) translateY(-50%) scale(1) translateZ(0);
  }

  to {
    transform: translateX(-20%) translateY(-50%) scale(1.3) translateZ(0);
  }
}

@keyframes productImageLeave {
  from {
    transform: translateX(-20%) translateY(-50%) scale(1.3) translateZ(0);
  }

  to {

    transform: translateX(50%) translateY(-50%) scale(1) translateZ(0);
  }
}

@keyframes pulse {
  0% {
    transform: rotate(15deg) scale(1);
    box-shadow: 0 4px 12px rgba(255, 49, 118, 0.3);
  }
  50% {
    transform: rotate(15deg) scale(1.05);
    box-shadow: 0 6px 16px rgba(255, 49, 118, 0.5);
  }
  100% {
    transform: rotate(15deg) scale(1);
    box-shadow: 0 4px 12px rgba(255, 49, 118, 0.3);
  }
}

@media (min-width: 1920px) {
  .masonry-container > .card {
    width: calc(20% - 15px);
  }
}

@media (max-width: 1919px) and (min-width: 1600px) {
  .masonry-container > .card {
    width: calc(20% - 15px);
  }
}

@media (max-width: 1599px) and (min-width: 1200px) {
  .masonry-container > .card {
    width: calc(25% - 9px);
  }
}

@media (max-width: 1199px) and (min-width: 992px) {
  .masonry-container > .card {
    width: calc(33.333% - 8px);
  }
}

@media (max-width: 991px) and (min-width: 768px) {
  .masonry-container {
    padding: 8px;

    > .card {
      width: calc(50% - 6px);
      margin-bottom: 8px;

      .badge-container {
        top: -6px;
        right: -6px;
      }

      .seckill-text-badge {
        font-size: 18px;
      }

      .commission-text-badge {
        font-size: 18px;
      }

      .card_content {
        padding: 8px;
      }
    }
  }
}

@media (max-width: 767px) and (min-width: 576px) {
  .masonry-container {
    padding: 6px;

    > .card {
      width: calc(50% - 4px);
      margin-bottom: 6px;

      .badge-container {
        top: -5px;
        right: -5px;
      }

      .seckill-text-badge {
        font-size: 16px;
      }

      .commission-text-badge {
        font-size: 16px;
      }

      .card_content {
        padding: 10px;
      }
    }
  }
}

@media (max-width: 575px) {
  .masonry-container {
    padding: 4px;

    > .card {
      width: 100%;
      margin-bottom: 4px;

      .badge-container {
        top: -4px;
        right: -4px;
      }

      .seckill-text-badge {
        font-size: 14px;
      }

      .commission-text-badge {
        font-size: 14px;
      }

      .card_content {
        padding: 8px;

        .content-wrapper > span {
          font-size: 13px;
          margin: 3px 0;
        }
      }
    }
  }
}
.popperClass {
  max-height: 600px;
  overflow-y: auto;
  overflow-x: hidden;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.popperClass::-webkit-scrollbar {
  width: 6px;
}

.popperClass::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.popperClass::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.popperClass::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.text {
  text-align: center;
  margin: 15% auto;
  font-size: 32px;
  font-weight: 300;
  background: linear-gradient(135deg, #FF8B87 0%, #FFD4E3 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  padding: 20px;
}

@media (max-width: 768px) {
  .text {
    font-size: 24px;
    margin: 20% auto;
  }
}

@media (max-width: 480px) {
  .text {
    font-size: 20px;
    margin: 25% auto;
  }
}.seckill-badge {
  position: absolute;
  top: -10px;
  right: -10px;
  width: 70px;
  height: 70px;
  transform: rotate(15deg);
  /* 倾斜展示 */
  z-index: 44;
  //filter: drop-shadow(2px 2px 4px rgba(0, 0, 0, 0.3));
  /* 添加阴影增强视觉效果 */
}
/* 在线链接服务仅供平台体验和调试使用，平台不承诺服务的稳定性，企业客户需下载字体包自行发布使用并做好备份。 */
@font-face {
  font-family: "font_ms";font-weight: 400;src: url("//at.alicdn.com/wf/webfont/Z6Z6Ve9CViat/PZLjWH8qhBiv.woff2") format("woff2"),
url("//at.alicdn.com/wf/webfont/Z6Z6Ve9CViat/gKkNeU0et3ML.woff") format("woff");font-variation-settings: normal;font-display: swap;
}
@font-face {
  font-family: "font_gy";font-weight: 400;src: url("//at.alicdn.com/wf/webfont/Z6Z6Ve9CViat/bnfgMG0zk4p8.woff2") format("woff2"),
url("//at.alicdn.com/wf/webfont/Z6Z6Ve9CViat/ljSOasxviSNa.woff") format("woff");font-variation-settings: normal;font-display: swap;
}
</style>
